module.exports = __webpack_public_path__ + "static/media/text_analyze_video.ccca9b99.mp4";